"use client";

import { useState } from "react";

interface ChartPdfDownloadButtonProps {
  chartTitle?: string;
  isHindi?: boolean;
  className?: string;
}

export default function ChartPdfDownloadButton({
  chartTitle = "Janam Kundali Summary",
  isHindi = false,
  className = "",
}: ChartPdfDownloadButtonProps) {
  const [downloading, setDownloading] = useState(false);

  const handlePrintDownload = () => {
    setDownloading(true);
    try {
      window.print();
    } catch {
      // Browser print fallback
    } finally {
      setTimeout(() => setDownloading(false), 1000);
    }
  };

  return (
    <button
      type="button"
      onClick={handlePrintDownload}
      disabled={downloading}
      className={`inline-flex items-center gap-2 rounded-xl border border-border-default bg-surface-raised px-4 py-2 text-body-small font-bold text-text-primary hover:bg-surface-warm transition-all shadow-xs disabled:opacity-50 ${className}`}
      aria-label={isHindi ? "कुंडली PDF डाउनलोड करें" : `Download ${chartTitle} PDF`}
    >
      <span>📄</span>
      <span>
        {downloading
          ? isHindi
            ? "तैयार किया जा रहा है..."
            : "Preparing PDF..."
          : isHindi
            ? "1-Page कुंडली PDF डाउनलोड करें"
            : "Download 1-Page Kundli PDF"}
      </span>
    </button>
  );
}
